/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { Modal } from 'antd';
import React from 'react';
import classNames from 'classnames';
import MiniPlayground from '../components/MiniPlayground/MiniPlayground';
import styles from './MiniPlaygroundPopup.module.less';
import { IMiniPlaygroundProps } from '../components/MiniPlayground/interface';

interface IProps extends IMiniPlaygroundProps {}

function MiniPlaygroundPopup(props: IProps) {
  return (
    <Modal
      open
      onCancel={props.onClose}
      keyboard={false}
      maskClosable={false}
      footer={null}
      width={800}
      className={classNames(
        styles.miniPlaygroundPopup,
        'mini-playground-popup'
      )}
      destroyOnClose
    >
      <MiniPlayground {...props} />
    </Modal>
  );
}

export default MiniPlaygroundPopup;
